export const buttonStyles = Object.freeze({
  DEFAULT: 'default',
  COMPACT: 'compact',
  COMPACT_MIN: 'compact--minimal',
  WHITE: 'white',
});

export const SHUFFLE_TYPES = Object.freeze({
  ALL: 'all',
  MY: 'my',
});
